import { useEffect, useRef, useState } from 'react';
import { FORM_CONSTANTS } from '../constants/formConstants';

export const useAutoSave = (formValues, saveDraft, isEditing) => {
  const timeoutRef = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const initialValuesRef = useRef(null);

  // Initialize after first render to avoid saving default values immediately
  useEffect(() => {
    const timer = setTimeout(() => {
      initialValuesRef.current = formValues;
      setIsInitialized(true);
      console.log('🚀 Auto-save initialized');
    }, 1000); // Wait 1 second before enabling auto-save

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isEditing && isInitialized) {
      // Check if values actually changed from initial state
      const hasChanges = JSON.stringify(formValues) !== JSON.stringify(initialValuesRef.current);
      
      if (hasChanges) {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        timeoutRef.current = setTimeout(() => {
          console.log('💾 Auto-saving draft after changes detected');
          saveDraft();
        }, FORM_CONSTANTS.AUTO_SAVE_DELAY);
        
        return () => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
        };
      }
    }
  }, [formValues, isEditing, saveDraft, isInitialized]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};